import axios from '../axios-common';

class CrudBase {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }

  get = id => axios.get(`${this.endpoint}/${id}`);
  list = () => axios.get(this.endpoint);
  create = data => axios.post(this.endpoint, data);
  update = data => axios.put(this.endpoint, data);
  delete = id => axios.delete(`${this.endpoint}/${id}`);
  search = data => axios.post(`${this.endpoint}/search`, data);
  findByText = text => axios.get(`${this.endpoint}?text=${text}`);
  export = data => axios.post(`${this.endpoint}/export`, data, { responseType: 'blob' });

  defaultMethods = {
    get: this.get,
    list: this.list,
    create: this.create,
    update: this.update,
    delete: this.delete,
    search: this.search,
    findByText: this.findByText,
    export: this.export,
  }
}

export default CrudBase;
